export default __webpack_public_path__ + "static/2-89e3e594f3309058558ca98e604ae599.jpg";